import { Box, Typography, Paper } from '@mui/material';
import { DateRange } from '@mui/icons-material';
import { motion } from 'framer-motion';

const BookingFlow = () => {
  return (
    <Box sx={{ p: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
          Book Appointment
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Customer booking flow for appointments
        </Typography>
        
        <Paper sx={{ p: 4, textAlign: 'center', mt: 3 }}>
          <DateRange sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Booking Flow
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This feature is coming soon. Customers will be able to book appointments here.
          </Typography>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default BookingFlow;
